import React from 'react';
import '../styles/About.css';

function About() {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <div className="about-hero">
        <div className="container">
          <h1>Sobre a ABRALIBER</h1>
          <p className="hero-subtitle">Transformando vidas através da educação de qualidade e acessível</p>
        </div>
      </div>

      {/* Container Principal */}
      <div className="about-container">
        {/* Nossa História */}
        <div className="about-section">
          <div className="section-header">
            <h2>Nossa História</h2>
            <div className="section-divider"></div>
          </div>
          <div className="content-card">
            <p>A Associação Brasileira Libertas (ABRALIBER) nasceu da visão de democratizar o acesso à educação de qualidade no Brasil. Fundada com o compromisso de transformar vidas através do conhecimento, nossa instituição representa um marco na educação continuada e desenvolvimento profissional.</p>
            <p>Desde nossa criação, dedicamos nossos esforços para criar uma plataforma educacional que combina excelência acadêmica com tecnologia de ponta, oferecendo uma experiência de aprendizagem única e transformadora para milhares de estudantes em todo o país.</p>
          </div>
        </div>

        <div className="about-section">
          <div className="section-header">
            <h2>Identificação Institucional</h2>
            <div className="section-divider"></div>
          </div>
          <div className="content-card institutional-card">
            <span>ABRALIBER</span>
            <strong>CNPJ 65.983.758/0001-32</strong>
          </div>
        </div>

        {/* Nossa Missão */}
        <div className="about-section">
          <div className="section-header">
            <h2>Nossa Missão</h2>
            <div className="section-divider"></div>
          </div>
          <div className="content-card mission-card">
            <p className="mission-text">Proporcionar educação de excelência, acessível e transformadora, capacitando indivíduos para o sucesso profissional e pessoal através de metodologias inovadoras e conteúdo relevante para o mercado atual.</p>
          </div>
        </div>

        {/* Nossos Valores */}
        <div className="about-section">
          <div className="section-header">
            <h2>Nossos Valores</h2>
            <div className="section-divider"></div>
          </div>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">🎯</div>
              <h3>Excelência</h3>
              <p>Oferecemos conteúdo de alta qualidade, desenvolvido por especialistas reconhecidos em suas áreas de atuação.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🌐</div>
              <h3>Acessibilidade</h3>
              <p>Democratizamos o acesso à educação, tornando-a disponível independentemente de localização ou condição socioeconômica.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🚀</div>
              <h3>Inovação</h3>
              <p>Utilizamos tecnologias avançadas e metodologias modernas para criar experiências de aprendizagem excepcionais.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🤝</div>
              <h3>Compromisso</h3>
              <p>Estamos dedicados ao sucesso de nossos alunos e ao impacto positivo que geramos na sociedade.</p>
            </div>
          </div>
        </div>

        {/* Por que Escolher a ABRALIBER */}
        <div className="about-section">
          <div className="section-header">
            <h2>Por que Escolher a ABRALIBER?</h2>
            <div className="section-divider"></div>
          </div>
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-number">01</div>
              <div className="benefit-content">
                <h3>Certificação Digital</h3>
                <p>Certificados digitais de conclusão para comprovação de cursos livres</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-number">02</div>
              <div className="benefit-content">
                <h3>Metodologia Comprovada</h3>
                <p>Ensino estruturado com foco na aplicação prática do conhecimento</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-number">03</div>
              <div className="benefit-content">
                <h3>Suporte Personalizado</h3>
                <p>Acompanhamento individual durante toda a jornada de aprendizagem</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-number">04</div>
              <div className="benefit-content">
                <h3>Flexibilidade Total</h3>
                <p>Estude no seu ritmo, quando e onde quiser, com acesso 24/7</p>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="about-section">
          <div className="section-header">
            <h2>Faça Parte da Nossa Comunidade</h2>
            <div className="section-divider"></div>
          </div>
          <div className="content-card cta-card">
            <p>Junte-se a milhares de estudantes que já transformaram suas carreiras através da educação de qualidade da ABRALIBER. Explore nossos cursos, conecte-se com nossa comunidade e descubra como podemos ajudá-lo a alcançar seus objetivos educacionais e profissionais.</p>
            <div className="cta-buttons">
              <a href="/cursos" className="btn-primary">Explorar Cursos</a>
              <a href="/contato" className="btn-secondary">Entre em Contato</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
